export { AppIconRenderer } from './AppIconRenderer'
